import * as React from "react";
import { SVGProps } from "react";

export const IconProcessRecording = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={17}
    viewBox="0 0 18 17"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.1 10.273V15.3a.9.9 0 001.8 0v-5.027l1.164 1.163a.9.9 0 001.272-1.272l-2.7-2.7a.899.899 0 00-1.272 0l-2.7 2.7a.9.9 0 001.272 1.272L8.1 10.273zM1.8 5.4h14.4v7.2h-1.8a.9.9 0 000 1.8h2.7a.9.9 0 00.9-.9V1.8a.9.9 0 00-.9-.9H7.408L5.79.094A.898.898 0 005.389 0H.9a.9.9 0 00-.9.9v12.6a.9.9 0 00.9.9h2.7a.9.9 0 000-1.8H1.8V5.4z"
      fill="currentColor"
    />
  </svg>
);
